import React from "react";
import ActiveSlider from "./Pages/Home/ActiveSlider";
import SecondComponent from "./Pages/Home/SecondComponent";
import ThirdComponent from "./Pages/Home/ThirdComponent";
import FourthComponent from "./Pages/Home/FourthComponent";

const Home = () => {
  return (
    <>
      <ActiveSlider />
      <SecondComponent />
      <ThirdComponent />
      <FourthComponent />
    </>
  );
};

export default Home;
